import { render } from "./SortTableRegistrationStepCellComponent.vue?vue&type=template&id=863fa2dc"
import script from "./SortTableRegistrationStepCellComponent.vue?vue&type=script&lang=js"
export * from "./SortTableRegistrationStepCellComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__